import React from "react";
import Header from "../../components/header/Header";
import FormValidation from "../../components/form/FormValidation";

const Contact = () => {
  return (
    <div>
      <Header text="CONTACT" />
      <FormValidation />
    </div>
  );
};

export default Contact;